import { render, staticRenderFns } from "./ResizeModal.vue?vue&type=template&id=07a77004&scoped=true"
import script from "./ResizeModal.vue?vue&type=script&lang=js"
export * from "./ResizeModal.vue?vue&type=script&lang=js"
import style0 from "./ResizeModal.vue?vue&type=style&index=0&id=07a77004&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a77004",
  null
  
)

export default component.exports